export const CONSTANTS = {
  NoData: 'Немає даних для відображення.',
};
